import { createStoreSelector } from "../selectors";
export const selectBenefits = (state) => createStoreSelector(state, 'benefits')(state);
//# sourceMappingURL=benefits.selectors.js.map